import { konamiCode } from '@functions/gamifications';
import { clearLocalStorage, getLocalStorage, setLocalStorage } from '@functions/localStorage';
import { STORAGE_VERSION } from '@utils/variables';
import { FC, useCallback, useEffect } from 'react';
import useLogout from './hooks/useLogout';

const UserStore: FC = () => {
	const { logout } = useLogout();

	// ============================================================
	// ===================== EASTER EGG ===========================
	// ============================================================
	const easerEggFound = useCallback((type: string) => {
		if (type === 'konami') {
			console.debug('Konami code found');
		}
	}, []);

	useEffect(() => {
		// easter egg
		konamiCode(() => easerEggFound('konami'));
	}, [easerEggFound]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			const storageVersion = getLocalStorage<number | string>('storage-version');

			if (!storageVersion) {
				setLocalStorage('storage-version', STORAGE_VERSION);
			} else if (!!storageVersion && storageVersion.toString() !== STORAGE_VERSION) {
				clearLocalStorage();
				setLocalStorage('storage-version', STORAGE_VERSION);
				logout();
			}
		}, 200);

		return () => clearTimeout(timeout);
	}, [logout]);

	return null;
};

export default UserStore;
